export default "/images/framework/Referfriend.ee6cc9a5.svg?ee6cc9a5";